import { render, staticRenderFns } from "./NavBarMenu.vue?vue&type=template&id=620ed0d1&scoped=true"
import script from "./NavBarMenu.vue?vue&type=script&lang=ts"
export * from "./NavBarMenu.vue?vue&type=script&lang=ts"
import style0 from "./NavBarMenu.vue?vue&type=style&index=0&id=620ed0d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620ed0d1",
  null
  
)

export default component.exports